import {
  STORAGE_KEY__COMPONENT_STATUS,
  abTestKey,
  viewedProductsKey
} from '../variables.ts'

export function setLocalStorage(name, value, { isJsonFormat = true } = {}) {
  window.localStorage.setItem(
    name,
    isJsonFormat ? JSON.stringify(value) : value
  )
}

export function getLocalStorage(name, { isJsonFormat = true } = {}) {
  return isJsonFormat
    ? JSON.parse(window.localStorage.getItem(name))
    : window.localStorage.getItem(name)
}

export function removeLocalStorage(name) {
  window.localStorage.removeItem(name)
}

/**
 * Component Status
 */
const getComponentStatusKey = componentLayout => componentLayout

export function getComponentStatus(componentLayout) {
  const status = getLocalStorage(STORAGE_KEY__COMPONENT_STATUS)
  const key = getComponentStatusKey(componentLayout)
  const componentStatus = status ? status[key] : null

  return componentStatus ?? null
}
export function setComponentStatus(componentLayout, valueObject) {
  const componentStatus = getComponentStatus(componentLayout)
  const key = getComponentStatusKey(componentLayout)

  setLocalStorage(STORAGE_KEY__COMPONENT_STATUS, {
    [key]: {
      ...componentStatus,
      ...valueObject
    }
  })
}

export function getViewedProductIds() {
  return getLocalStorage(viewedProductsKey)
}

export function getAbTestGroup() {
  const storageValue = getLocalStorage(abTestKey, { isJsonFormat: false })
  const value =
    storageValue === 'control' || storageValue === 'experiment'
      ? storageValue
      : Math.random() < 0.5
      ? 'control'
      : 'experiment'

  if (value !== storageValue) {
    setLocalStorage(abTestKey, value, { isJsonFormat: false })
  }

  return value
}
